import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ProFeatureModalService } from '@Shared/services/pro-feature-modal.service';

@Component({
  selector: 'app-pro-feature-modal',
  templateUrl: './pro-feature-modal.component.html',
  styleUrls: ['./pro-feature-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule]
})
export class ProFeatureModalComponent implements OnInit {
  visible = false;

  constructor(
    private proFeatureModalService: ProFeatureModalService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.proFeatureModalService.isVisible$.subscribe((isVisible) => {
      this.visible = isVisible;
    });
  }

  onHide(): void {
    this.proFeatureModalService.hide();
  }

  /** PrimeNG 20+: close button emits visibleChange(false), not onHide */
  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.onHide();
    }
  }

  upgradeToPro(): void {
    this.proFeatureModalService.hide();
    this.router.navigate(['/pricing']);
  }

  maybeLater(): void {
    this.proFeatureModalService.hide();
  }
}
